/* « Missions à relire » : missions livrées dont le client n'a pas encore
   ouvert les résultats depuis la livraison. Simple confort propre à ce
   navigateur (localStorage) : sans stockage, toutes les livraisons récentes
   restent signalées, rien ne casse. */

const CLE = 'tribe-resultats-vus';

function lire(): Record<string, string> {
  try {
    const brut = localStorage.getItem(CLE);
    const v = brut ? JSON.parse(brut) : {};
    return v && typeof v === 'object' ? v : {};
  } catch {
    return {};
  }
}

/** Marque les résultats d'une mission comme vus maintenant. */
export function marquerResultatsVus(questId: string, maintenant = new Date().toISOString()): void {
  try {
    const vus = lire();
    vus[questId] = maintenant;
    localStorage.setItem(CLE, JSON.stringify(vus));
  } catch {
    /* stockage indisponible : la mission restera signalée */
  }
}

/** Vrai si la livraison (date ISO) est postérieure à la dernière consultation des résultats. */
export function resultatsARelire(questId: string, livreeLe: string): boolean {
  const vu = lire()[questId];
  return !vu || (!!livreeLe && livreeLe > vu);
}
